/**
 * The query key of the maintenance state.
 */
export const maintenanceStateQueryKey = ['system', 'maintenance', 'state'] as const;
